<template>
  <div class="d-flex w-100 h-100 flex-column justify-content-center">
    <div class="card mx-auto flex-grow-0 flex-shrink-0 shadow-lg" style="width: 18rem;">
      <div class="card-body">
        <form @submit.prevent="login">
          <legend>Вход в панель</legend>
          <div class="form-group">
            <label>Логин</label>
            <input type="text" class="form-control" v-model="data.body.username">
          </div>
          <div class="form-group">
            <label>Пароль</label>
            <input type="password" class="form-control" v-model="data.body.password">
          </div>
<!--          <div class="form-group">-->
<!--            <div class="form-check form-check-inline">-->
<!--              <input class="form-check-input" type="checkbox" id="rememberMe" v-model="data.rememberMe">-->
<!--              <label class="form-check-label" for="rememberMe">Запомнить меня</label>-->
<!--            </div>-->
<!--          </div>-->
          <div class="alert alert-danger" role="alert" v-if="error">
            {{error}}
          </div>
          <button class="btn btn-primary btn-block" type="submit">Войти</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      context: 'login context',
      data: {
        body: {
          username: null,
          password: null,
        },
        rememberMe: false,
        fetchUser: false,
      },
      error: null,
    };
  },
  methods: {
    login() {
      const redirect = this.$auth.redirect();
      this.error = null;
      this.$auth.login({
        // body: this.data.body, // Vue-resource
        data: this.data.body, // Axios
        rememberMe: this.data.rememberMe,
        // redirect: { name: redirect ? redirect.from.name : 'account' },
        fetchUser: this.data.fetchUser,
        async success(res) {
          this.$auth.user(res.data);
          await this.$store.dispatch('fetchPaymentTypes');
          await this.$store.dispatch('fetchPartnerGroups');
        },
        error(res) {
          console.log(`error ${res.data}`);
          this.error = res.response.data;
        },
      });
      // .then((a, b, c) => {
      //   this.$auth.user(a.data);
      //   console.log(a, b, c);
      //   console.log(`success ${this.context}`);
      //   // setTimeout(() => {
      //   //   console.log(this.$auth.user())
      //   // },1000);
      // }, (res, qwe) => {
      //   console.log(`error ${this.context}`);
      //   console.log(res.response);
      //   this.error = res.response.data;
      // });
    },
  },
};
</script>
